import qs, { StringifyOptions, ParseOptions } from 'query-string';
import { encodeNestedDateValues, transformNestedDateValues } from 'vl-common/src/services/service.api';

export default {
  ...qs,
  stringify: (o: any, options?: StringifyOptions) => qs.stringify(encodeNestedDateValues(o), options),
  parse: (s: string, options?: ParseOptions) => transformNestedDateValues(qs.parse(s, options))
};
